module.exports = __webpack_public_path__ + "img/29exp.d2089fb0.jpg";